import NoRecord from '../common/NoContent/NoRecord'
import React from 'react'
import Table from '../common/DDS/Table/Table'

interface PaginatedTableProps<T> {
  data: T[]
  columns: any[]
  currentPage: number
  rowsPerPage: number
  totalCount?: number
  onPageChange: (page: number) => void
  searchTerm?: string
  noDataText?: string
  noSearchMatchText?: string
  noDataImage?: any
  noSearchImage?: any
}

export const PaginatedTable = <T,>({
  data,
  columns,
  currentPage,
  rowsPerPage,
  totalCount,
  onPageChange,
  searchTerm,
  noDataText = 'No data available.',
  noSearchMatchText = 'No results match your search.',
  noDataImage,
  noSearchImage
}: PaginatedTableProps<T>) => {
  const hasData = data?.length > 0
  const hasSearchTerm = !!searchTerm?.trim()

  return (
    <div className='flex flex-col justify-center items-center text-center pt-[12px]'>
      {hasData ? (
        <Table
          columns={columns}
          data={data}
          totalCount={totalCount ?? data.length}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
        />
      ) : hasSearchTerm ? (
        <NoRecord
          imageSrc={noSearchImage}
          style={{
            height: '45vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
          }}
          text={<div>{noSearchMatchText}</div>}
        />
      ) : (
        <NoRecord
          imageSrc={noDataImage}
          style={{
            height: '45vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
          }}
          text={<div>{noDataText}</div>}
        />
      )}
    </div>
  )
}
